import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../../actions/root_url';

export const fetchSODetailWitSONum = (SONum) => {
  // dispatch/shipping/
  axios({
    method: 'GET',
    // data: { ContainerNo: CTNNo },
    url: `${ROOT_URL}v1/dispatch/shipping/${SONum}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    console.log('res', res);
  }, err => {
    alert(err);
  });
};

export const changeStatus = (currentStatus, salesOrderId, payload, isPartial, success) => {
  let status = '';
  if ((currentStatus === 'Inbound' || currentStatus === 'Partial_Outbound') && !isPartial) {
    status = 'Outbound';
  } else if (isPartial) {
    status = 'Partial_Outbound';
  } else {
    status = 'Inbound';
  }

  axios({
    method: 'PUT',
    data: payload,
    url: `${ROOT_URL}v1/oversea-warehouse/update-sales-order/${salesOrderId}/${status}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  })
  .then(res => {
    success();
  }, err => {
    alert(err);
  });
}


// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/action.jsx